<template>
	<div class="new-team-member-row-layout">
		<div class="new-team-member-row-layout__layout-column new-team-member-row-layout__layout-column--center">
			<div class="new-team-member-row-layout__email-column">
				<slot name="email"></slot>
			</div>
			<div class="new-team-member-row-layout__status-column">
				<slot name="status"></slot>
			</div>
			<div class="new-team-member-row-layout__role-column">
				<slot name="role"></slot>
			</div>
		</div>
		<div class="new-team-member-row-layout__remove-column">
			<slot name="remove"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "NewTeamMemberRowLayout",
	teamingPackage: "common-team",
};
</script>

<style lang="scss">
.new-team-member-row-layout__status-column {
	.user-avatar-spread {
		align-items: center;
		display: flex;
	}

	.user-avatar-spread__avatar {
		margin-right: .25rem;
	}
}

.new-team-member-row-layout__role-column {
	.user-avatar-spread {
		align-items: center;
		display: flex;
	}

	.user-avatar-spread__avatar {
		margin-right: .25rem;
	}
}
</style>

<style lang="scss" scoped>
.new-team-member-row-layout {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;
	gap: 1rem;
	box-sizing: border-box;

	padding: 0 1rem;
	height: 3.75rem;

	@include for-size('md') {
		padding: 0 1.6025rem;
	}
}

.new-team-member-row-layout__layout-column {
	display: inline-flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 1rem;
}

.new-team-member-row-layout__layout-column--center {
	flex: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;
}

.new-team-member-row-layout__favorite-column,
.new-team-member-row-layout__remove-column {
	flex: 3rem;
	justify-content: center;
}

.new-team-member-row-layout__favorite-column {
	flex: 2rem;
	justify-content: flex-start;

	@include for-size('md') {
		flex: 3rem;
		justify-content: center;
	}
}

.new-team-member-row-layout__remove-column {
	display: inline-flex;
}

.new-team-member-row-layout__email-column,
.new-team-member-row-layout__status-column,
.new-team-member-row-layout__role-column {
	width: 100%;

	@include for-size('sm') {
		width: 50%;
	}

	@include for-size('md') {
		width: 33.33%;
	}
}

.new-team-member-row-layout__status-column {
	display: inline-flex;

	@include for-size-and-smaller('sm') {
		display: none;
	}
}

.new-team-member-row-layout__role-column {
	display: inline-flex;
}
</style>
